import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, IconButton as MUIIconButton, } from "@mui/material";
import { Icon } from "../Icon";
import { convertPxToRem } from "../../util-functions";
const StyledIconButton = styled(MUIIconButton, {
    shouldForwardProp: (prop) => prop !== "small",
})(({ theme }) => ({
    transition: `all 0.2s`,
    "&:active": {
        transform: "scale(0.95)",
    },
    "&:disabled": {
        backgroundColor: theme.palette.grey03.main,
    },
    "&.Mui-focusVisible": {
        outline: `${convertPxToRem(2.5)} solid ${theme.palette.primaryBlack.main}`,
    },
}));
const StyledPrimaryIconButton = styled(StyledIconButton)(({ theme }) => ({
    backgroundColor: theme.palette.sativaGreen.main,
    "&:active, &:hover": {
        backgroundColor: theme.palette.green06.main,
    },
}));
const StyledSecondaryIconButton = styled(StyledIconButton)(({ theme }) => ({
    "&:active, &:hover": {
        backgroundColor: theme.palette.grey03.main,
    },
    "&:disabled": {
        backgroundColor: "transparent",
    },
}));
const StyledStateIconButton = styled(StyledIconButton)(({ theme }) => ({
    backgroundColor: theme.palette.midribGreen.main,
    "&:active, &:hover": {
        backgroundColor: theme.palette.sativaGreen.main,
    },
}));
export const IconButton = ({ disabled = false, iconName, onClick, size = "medium", testId, variant = "primary", }) => {
    const enabledIconColor = disabled ? "disabledText" : "primaryBlackText";
    const fontSize = size === "large" ? "large" : size === "medium" ? "medium" : "small";
    return (_jsxs(_Fragment, { children: [variant === "primary" && (_jsx(StyledPrimaryIconButton, Object.assign({ "aria-label": `${iconName}-button`, "data-testid": testId, disabled: disabled, onClick: onClick, size: size, disableRipple: true }, { children: _jsx(Icon, { color: enabledIconColor, fontSize: fontSize, iconName: iconName }) }))), variant === "secondary" && (_jsx(StyledSecondaryIconButton, Object.assign({ "aria-label": `${iconName}-button`, "data-testid": testId, disabled: disabled, onClick: onClick, size: size, disableRipple: true }, { children: _jsx(Icon, { color: enabledIconColor, fontSize: fontSize, iconName: iconName }) }))), variant === "state" && (_jsx(StyledStateIconButton, Object.assign({ "aria-label": `${iconName}-button`, "data-testid": testId, disabled: disabled, onClick: onClick, size: size, disableRipple: true }, { children: _jsx(Icon, { color: enabledIconColor, fontSize: fontSize, iconName: iconName }) })))] }));
};
